import React, { useRef } from 'react';
import { useInView } from 'framer-motion';
import { AlertTriangle } from 'lucide-react';
interface AnnouncementBarProps {
  copiesLeft: number;
}
export function AnnouncementBar({
  copiesLeft
}: AnnouncementBarProps) {
  const ref = useRef<HTMLDivElement>(null);
  // Stop the marquee from repainting while it is scrolled out of view.
  const inView = useInView(ref, {
    amount: 0.1
  });
  const message = `ATENCIÓN: Solo quedan ${copiesLeft} copias al precio de lanzamiento — Oferta expira pronto`;
  return <div ref={ref} className="relative z-50 overflow-hidden border-b border-crimson-500/40 bg-crimson-600" data-id="element-1" data-mp="5t9900jniruo">
      <div className="flex w-max animate-marquee items-center py-2.5" style={{
      animationPlayState: inView ? 'running' : 'paused'
    }} data-id="element-2" data-mp="vhlrjtybtwt">
        {[0, 1].map(group => <div key={group} className="flex items-center" aria-hidden={group === 1} data-id="element-3" data-mp="1v8qn2occg93z">
            {Array.from({
          length: 4
        }).map((_, index) => <span key={index} className="flex items-center gap-2.5 whitespace-nowrap px-7 text-[11px] font-bold uppercase tracking-widest2 text-white sm:text-xs" data-id="element-4" data-mp="68i7pptbhufg" data-mpi={index}>
                <AlertTriangle className="h-3.5 w-3.5 shrink-0" aria-hidden="true" data-id="element-5" data-mp="3sfzys3i91mbd" />
                {message}
              </span>)}
          </div>)}
      </div>
      <span className="sr-only" data-id="element-6" data-mp="oyriho366uir">{message}</span>
    </div>;
}